exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".snippet{background-color:#000;padding:4px;margin:4px 0;font-size:12px}", ""]);

